import styled from "styled-components";
import EmployeesWrapper from "../../layout/EmployeesWrapper";
import { Button } from "../../styles";
import { ICON_PLUS } from "../../utils/icons";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import AddStaff from "../../components/user/employees/AddStaff";
import { useEmployeeContext } from "../../context/employee_context";
import EmptyData from "../../components/EmptyData";
import { userAvatar } from "../../assets";
import MiniLoader from "../../utils/MIniLoader";


function Employees() {

  const {
    openAddStaff,
    staffLoading, getStaffData, allStaffs
  } = useEmployeeContext();


  useEffect(() => {
    getStaffData();
  }, []);

  return (
    <EmployeesWrapper
      title={'Staff'}
    >
      <StyledEmployees>
        <div className="main-container">

          <div className="d-flex justify-content-between">
            <div className="mb-4 d-flex align-items-center">
              <h5 className="grey-bold-text">
                All Employees
              </h5>
              <MiniLoader
                load={staffLoading}
              />
            </div>
            <Button pry
              className="btn"
              onClick={() => openAddStaff()}
            >
              {ICON_PLUS} Add Employee
            </Button>
          </div>

          <div className="my-5">
            <EmptyData
              data={allStaffs}
              title='Staffs'
            />

            <div className="row text-center">
              {allStaffs.map((item) => {
                const { fullname, mail, position, usertoken, photo } =
                  item;
                return (
                  <div className="col-md-6 col-lg-4" key={usertoken}>
                    <Link to={`/user/employees/${ usertoken }`}>

                      <div className=" sec-bold pry-bold-text pt-2 mb-3">

                        <div className="img-container mx-auto">
                          <img src={photo || userAvatar} alt={fullname} />
                        </div>


                        <h6 className="fw-bold mb-0"> {fullname} </h6>
                        <small > {mail} </small>
                        <h6 className="fw-bold pry-bold-text mx-auto mb-0 light-bg py-2 px-3 fit-content br-sm mt-2"> Manager {position} </h6>

                        <div className="pb-2 pt-5">
                          <small className="grey-text"> Logged in - 10/10/2000</small>
                        </div>
                      </div>

                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

      </StyledEmployees>

      <AddStaff
      />

    </EmployeesWrapper>
  );
}

export default Employees;

const StyledEmployees = styled.div`

.all-staff h5 {
  width: fit-content;
  margin-left: auto !important;
  margin-right: auto !important;
}

.all-staff .list {
  cursor: pointer;
  transition: 0.3s ease;
  padding: 5px;
}
.all-staff .list:hover {
  background: #f5f9fd !important;
  border-radius: 5rem !important;
  padding: 5px;
}
.all-staff .dropdown-menu-right {
  right: auto !important;
  left: 0 !important;
}
.addstaff .dropdown-menu-right {
  right: auto !important;
  left: 0 !important;
}

.img-container {
  border-radius: 5rem !important;
  width: 4rem !important;
  height: 4rem !important;
  padding: 0 !important;
  padding-bottom: 1rem !important;
  display: flex !important;
  margin-top: 1rem !important;
  
  
  img {
   border-radius: 5rem !important;
 }
}
`;